import { fontStyles } from '@/components/pdf/styles';
import { Text, View } from '@react-pdf/renderer';
import { format } from 'date-fns';
import { FunctionComponent } from 'react';

interface PurchaseOrderDocumentQuotationProps {
  orderName: string;
}

const PurchaseOrderDocumentQuotation: FunctionComponent<PurchaseOrderDocumentQuotationProps> = ({ orderName }) => {
  return (
    <View
      style={{
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Text style={{ fontSize: 24, ...fontStyles.bold, textAlign: 'right', marginRight: 20, marginBottom: 10 }}>
        Quotation
      </Text>

      <View
        style={{
          flexDirection: 'row',
          fontSize: 12
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 85 }}>Title:</Text>
        <Text style={{ ...fontStyles.italic }}>{orderName}</Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: 12
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 85 }}>Quote Date:</Text>
        <Text style={{ ...fontStyles.italic }}>{format(new Date(), 'MMMM do yyyy')}</Text>
      </View>
    </View>
  );
};

export default PurchaseOrderDocumentQuotation;
